export default __webpack_public_path__ + "e72fc3c73cca634e9c07545fa6a25a06.svg";